import { Direction } from '../constants/index';

export function getNextDates() {
  return [new Date(2018, 7, 10), new Date(2018, 8, 10), new Date(2018, 9, 10)];
}

export function generateCartItems(cart: any[], investmentType: string) {
  return cart.map(item => {
    return {
      amount: item.amount,
      itemType: investmentType,
      productId: item.productId,
      referItem: investmentType === Direction.SIP ? null : {},
    };
  });
}

export function generateOrderGenDate(date: Date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}-${`0${month}`.slice(-2)}-${`0${day}`.slice(-2)}`;
}



// WEBPACK FOOTER //
// ./utils/cartUtils.ts